import articles from "../articles/_generated";

const dateOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    timeZone: 'UTC'  // Force UTC to avoid timezone shifts
};

const locale = "en-US";

const WORDS_PER_MINUTE = 230;

export function formatDate(date) {
    return date.toLocaleDateString(locale, dateOptions);
}

export function stripFrontmatter(raw) {
    return raw.replace(/^---\n[\s\S]*?\n---\n/, "");
}

export function readingTime(slug) {
    const words = stripFrontmatter(articles[slug] || "").split(/\s+/).filter(Boolean).length;
    return `${Math.max(1, Math.round(words / WORDS_PER_MINUTE))} min read`;
}
